import React, { useContext, useEffect, useState } from "react";
import {
  parseURL,
  isValidGoToURL,
} from "account-portal-library/lib/helperFunctions";
import { GotoUrl, GotoUrlCookie } from "./gotoUrl.js";

const GotoUrlContext = React.createContext({});
GotoUrlContext.displayName = "GotoUrlContext";

export function useGotoUrlContext() {
  return useContext(GotoUrlContext);
}

export function withGotoUrl(WrappedComponent, brands = ["T"]) {
  return () => {
    const [gotoUrl, setGotoUrl] = useState();
    const searchParams = window.location.search;
    useEffect(() => {
      const urlParams = parseURL(searchParams);

      const gotoParam = Object.keys(urlParams).includes("goto")
        ? urlParams["goto"]
        : undefined;

      if (brands.some((brand) => isValidGoToURL(brand, gotoParam))) {
        GotoUrlCookie.set(gotoParam);
        setGotoUrl(new GotoUrl(gotoParam));
      }
    }, [searchParams]);

    const [gotoUrlContext, setGotoUrlContext] = useState({ initialUsername: undefined });
    useEffect(() => {
      if (gotoUrl && gotoUrl.passedUserId) {

        Promise.resolve(gotoUrl.passedUserId).then((userId) => {
          if(userId){
            setGotoUrlContext({
            initialUsername: userId,
            decryptEmail : gotoUrl.encryptedUserId
          });
        }
        })
      }
    }, [gotoUrl]);
    return (
      <GotoUrlContext.Provider
        value={gotoUrlContext}
      >
        <WrappedComponent />
      </GotoUrlContext.Provider>
    );
  };
}